<mat-drawer-container autosize="true">
  <mat-drawer
    #drawer
    [class.table-view]="isTableFieldTabSelected()"
    [mode]="(drawerMode$ | async) ?? 'side'"
    (closed)="onClose()"
    [opened]="indexerSidebarOpen$ | async"
    [position]="position"
    fixedInViewport
    mwlResizable
    [ngStyle]="resizeStyle"
    (resizing)="onResize($event)"
    (resizeStart)="onResizeStart()"
    (resizeEnd)="onResizeEnd($event)"
    (window:resize)="onWindowResize($event)"
    [validateResize]="onResizeValidate"
    [enableGhostResize]="false"
    disableClose="true"
  >
    <div
      class="resize-handle-left"
      [ngClass]="{ 'full-width-resize-overlay': resizeInProgress }"
      mwlResizeHandle
      [resizeEdges]="{ left: true }"
      (dblclick)="onResizeHandleDoubleClick()"
    ></div>
    <!--  [selectedIndex]="selectedTabIndex$ | async" -->
    <mat-tab-group
      #tabs
      color="accent"
      mat-align-tabs="center"
      class="mat-tab-fill-height"
      [selectedIndex]="selectedTabIndex()"
      (selectedIndexChange)="onTabChange($event)"
      preserveContent
    >
      @if (!isGuest) {
        <mat-tab aria-label="Indexer Tab">
          <ng-template mat-tab-label>
            <mat-icon>assignment</mat-icon>
          </ng-template>
          <ng-template matTabContent>
            <div class="indexer-contents">
              <div class="indexer-section">
                <app-indexer
                  #indexer
                  [archiveId]="archiveId"
                  [id]="documentId"
                  [secureId]="documentSecureId"
                  [fieldValues]="fieldValues"
                  [uniqueId]="uniqueId"
                  [viewerPageNumber]="viewerPageNumber"
                  [permissions]="permissions"
                  (dataXChangeMatchApplied)="
                    onIndexerDataXChangeMatchApplied($event)
                  "
                  (fieldFocused)="onIndexerFieldFocused($event)"
                  (fieldBlurred)="onIndexerFieldBlurred($event)"
                  (multiValueEntryRemoved)="
                    indexerFieldMultiValueEntryRemoved.emit($event)
                  "
                ></app-indexer>
              </div>
              @if (workflowProcessId > 0) {
                <div class="workflow-section">
                  <app-user-actions-panel
                    [queuedDocumentMetadata]="workflowQueueDocumentMetadata"
                    [documentId]="documentId"
                    [documentSecureId]="documentSecureId"
                    (actionExecuted)="onUserActionExecuted($event)"
                  ></app-user-actions-panel>
                </div>
              }
            </div>
          </ng-template>
        </mat-tab>
      }
      @if (showDocumentHistory) {
        <mat-tab aria-label="Document History Tab">
          <ng-template mat-tab-label>
            <mat-icon>folder</mat-icon>
          </ng-template>
          <ng-template matTabContent>
            <app-document-history
              [selected-document-ids]="[documentId]"
            ></app-document-history>
          </ng-template>
        </mat-tab>
      }
      @if (shouldShowTableFieldTab$ | async) {
        <mat-tab id="table-field-tab">
          <ng-template mat-tab-label>
            <mat-icon>table_view</mat-icon>
          </ng-template>
          <!-- Do not lazy load this since it is only being rendered if the user has already explicitly opened the table field. -->
          <app-table-field-grid
            #tableFieldGrid
            [archiveId]="archiveId"
            [editModeEnabled]="!this.isGuest"
            [viewingRevision]="viewingArchiveRevision"
            [overrideHeight]="tableFieldOverrideHeight()"
          ></app-table-field-grid>
        </mat-tab>
      }
    </mat-tab-group>
  </mat-drawer>
  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
